// extracted by mini-css-extract-plugin
export var backCopy = "ShipmentTracking_backCopy__3sy24";
export var container = "ShipmentTracking_container__-fERM";
export var disclaimer = "ShipmentTracking_disclaimer__qtsec";
export var feedbackButtonsContainer = "ShipmentTracking_feedbackButtonsContainer__DD3lO";
export var link = "ShipmentTracking_link__2djqP";
export var pageContent = "ShipmentTracking_pageContent__3xgaj";
export var shipmentDetails = "ShipmentTracking_shipmentDetails__OBKPv";
export var shipmentDetailsTitle = "ShipmentTracking_shipmentDetailsTitle__ncoEK";